/* =====================================================================
   CRO oct 2026 — portado a MAQUINA v3 (2026-10-16)
   1) Boton sticky de compra visible en movil desde que carga la PDP
      (se esconde cuando el boton real esta en pantalla o llega el footer).
   2) Guardia de talla en BOTAS: si tocan el sticky sin haber tocado la talla,
      NO se agrega: se baja a la talla, se marca y se avisa.
   Reversible: quitar el <script cp-cro.js> de layout/theme.liquid.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__cpCro) return;
  window.__cpCro = true;

  var mq = window.matchMedia('(max-width: 699px)');

  function mainForm() {
    var bar = document.querySelector('product-sticky-bar');
    if (!bar) return null;
    return { bar: bar, form: document.forms[bar.getAttribute('form')] };
  }

  function initSticky() {
    var first = mainForm();
    if (!first || !first.form) return;
    var formId = first.bar.getAttribute('form');
    var ticking = false;

    function paint() {
      ticking = false;
      var bar = document.querySelector('product-sticky-bar');
      var form = document.forms[formId];
      if (!bar || !form) return;
      var r = form.getBoundingClientRect();
      var formBelow = r.top > window.innerHeight;
      var footer = document.querySelector('.shopify-section--footer');
      var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var on = mq.matches && formBelow && !footerVisible;
      bar.classList.toggle('cp-visible', on);
      document.body.classList.toggle('cp-has-sticky', on || bar.classList.contains('is-visible'));
    }
    function schedule() { if (!ticking) { ticking = true; setTimeout(paint, 60); } }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    paint();
  }

  var sizeTouched = /[?&]variant=/.test(location.search);

  function sizeFieldset() {
    var ref = mainForm();
    if (!ref || !ref.form) return null;
    var sets = document.querySelectorAll('fieldset.variant-picker__option');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (!lg) continue;
      if (!/^(size|talla)/i.test(lg.textContent.trim())) continue;
      if (sets[i].closest('product-sticky-bar')) continue;
      return sets[i];
    }
    return null;
  }

  function isBoot() { return !!document.querySelector('[data-cp-promesa][data-cp-boot]'); }

  document.addEventListener('change', function (e) {
    var fs = e.target.closest && e.target.closest('fieldset.variant-picker__option');
    if (!fs || fs.closest('product-sticky-bar')) return;
    var lg = fs.querySelector('legend');
    if (lg && /^(size|talla)/i.test(lg.textContent.trim())) {
      sizeTouched = true;
      var hint = document.querySelector('.cp-size-hint');
      if (hint) hint.remove();
      fs.classList.remove('cp-size-pulse');
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('product-sticky-bar button[type="submit"]');
    if (!btn || sizeTouched || !isBoot()) return;
    var fs = sizeFieldset();
    if (!fs) return;
    e.preventDefault();
    e.stopPropagation();
    var y = fs.getBoundingClientRect().top + window.pageYOffset - (window.innerHeight / 3);
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    fs.classList.remove('cp-size-pulse');
    void fs.offsetWidth;
    fs.classList.add('cp-size-pulse');
    if (!fs.querySelector('.cp-size-hint')) {
      var p = document.createElement('p');
      p.className = 'cp-size-hint';
      p.setAttribute('role', 'status');
      p.textContent = 'Pick your size first, compa. If it doesn’t fit, the size exchange is on us.';
      fs.appendChild(p);
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();
